'use client';

import P from '@/components/typography/p';
import { cn } from '@/lib/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';

interface CopiableProps {
    label: string;
    value: string;
    children: React.ReactNode;
    className?: string;
}

const Copiable = ({ label, value, children, className }: CopiableProps) => {
    const [copied, setCopied] = useState<string | null>(null);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(label);
            setTimeout(() => setCopied(null), 3000);
        } catch (error) {
            console.error('Copy failed:', error);
        }
    };

    return (
        <span
            className="relative inline-block max-w-full cursor-pointer"
            onClick={handleCopy}
        >
            <span className={cn('wrap-break-word', className)}>{children}</span>

            <AnimatePresence>
                {copied === label && (
                    <motion.div
                        initial={{ opacity: 0, y: -6 }}
                        animate={{ opacity: 1, y: -20 }}
                        exit={{ opacity: 0, y: -6 }}
                        className="bg-lightyellow absolute -top-2 left-1/2 z-20 flex -translate-x-1/2 rounded border border-black px-4 py-1 whitespace-nowrap"
                    >
                        <P className="!text-[14px] !font-bold">COPIED!</P>
                    </motion.div>
                )}
            </AnimatePresence>
        </span>
    );
};

export default Copiable;

export function CopiableEmail({
    email,
    label,
    className,
}: {
    email: string;
    label?: string;
    className?: string;
}) {
    return (
        <Copiable
            value={email}
            label={label ?? email}
            className={cn(
                'underline decoration-2 underline-offset-4 hover:no-underline',
                className,
            )}
        >
            {email}
        </Copiable>
    );
}
